'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressesForm = exports.SELECTOR_PROVINCE = exports.SELECTOR_COUNTRY = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _CountryProvinceSelector = require('./../../objects/address/CountryProvinceSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR_COUNTRY = exports.SELECTOR_COUNTRY = '[data-address-form-country]';
var SELECTOR_PROVINCE = exports.SELECTOR_PROVINCE = '[data-address-form-province]';

var AddressesForm = exports.AddressesForm = function AddressesForm(container) {
  (0, _classCallCheck3.default)(this, AddressesForm);

  this.container = container;

  //Elements
  this.countrySelector = container.find(SELECTOR_COUNTRY);
  this.provinceSelector = container.find(SELECTOR_PROVINCE);

  this.countryProvinceSelector = new _CountryProvinceSelector.CountryProvinceSelector(this.countrySelector, this.provinceSelector);
};